"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "38", height: "30", viewBox: "0 0 38 30", className: "Icon toolbar-image-preview-on", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { fill: "#D9D9D9", d: "M1 1h36v28H1z" }),
            _react2.default.createElement("path", { fill: "#D9D9D9", d: "M1 1h36v28H1z" }),
            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M13 13l12 16H1z" }),
            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M29.5 20l7.5 9H22z" }),
            _react2.default.createElement("path", { d: "M28 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", fill: "#FFF" }),
            _react2.default.createElement("path", { stroke: "#000", d: "M1 1h36v28H1z", strokeWidth: "2" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/toolbar-image-preview-on.js
// module id = 1840
// module chunks = 0